import {computed, makeObservable, observable} from "mobx";
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {AbstractModel} from "./abstract-model";
import {dateToEsri, esriToDate} from "../utils/esri-utils";


export interface DocumentProps {
    objectId?: number;
    guid?: string;
    projectId?: number;
    fileName?: string;
    label?: string;
    date?: Date;
    fileSize?: number;
    creator?: string;
    createdAt?: Date;
    editor?: string;
    updatedAt?: Date;
}

/**
 * Technische Dokumentation zum Projekt
 */
@JsonObject()
export class Document extends AbstractModel {

    static readonly comparableAttributes: string[] = [
        "fileName", "label", "date", "fileSize"
    ];
    static readonly prototypeAttributes: string[] = [
        "OBJECTID", "GUID", "PROJ_ID", "FILENAME", "NAME_FULL", "CREADATE", "FILESIZE",
        "CREATED_USER", "CREATED_AT", "UPDATED_USER", "UPDATED_AT"
    ];
    // field mappings
    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "OBJECTID"],
        ["guid", "GUID"],
        ["projectId", "PROJ_ID"],
        ["fileName", "FILENAME"],
        ["label", "NAME_FULL"],
        ["date", "CREADATE"],
        ["fileSize", "FILESIZE"],
        ["creator", "CREATED_USER"],
        ["createdAt", "CREATED_AT"],
        ["editor", "UPDATED_USER"],
        ["updatedAt", "UPDATED_AT"]
    ]);

    class = "Document";
    typeLabel = "Technische Dokumentation";

    /**
     * Unique identifier
     */
    @JsonProperty({name: "GUID"})
        guid: string;

    /**
     * Projektschlüssel des zugehörigen Projekts
     */
    @JsonProperty({name: "PROJ_ID"})
        projectId: number;

    /**
     * Dateiname
     */
    @JsonProperty({name: "FILENAME"})
        fileName: string;

    /**
     * Dateigrösse
     */
    @JsonProperty({name: "FILESIZE"})
        fileSize: number;

    /**
     * Anzeigename
     */
    @JsonProperty({name: "NAME_FULL"})
        label: string;

    /**
     * Date of document
     */
    @JsonProperty({
        name: "CREADATE",
        beforeDeserialize: esriToDate,
        afterSerialize: dateToEsri
    })
        date: Date;

    constructor(props?: DocumentProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable, // do observe to reload when object is saved
            guid: observable,
            projectId: observable,
            fileName: observable,
            fileSize: observable,
            label: observable,
            date: observable,

            isAlterable: computed,

            creator: observable,
            createdAt: observable,
            editor: observable,
            updatedAt: observable,
            isNewRecord: computed
        });
    }

    get comparableAttributes(): string[] {
        return Document.comparableAttributes;
    }

    get isAlterable(): boolean {
        return true;
    }

}
